import _Vue from 'vue'
import Manager from './drag/manager'

export interface VageDragInterface {
  add(element: HTMLElement, config: VageConfig): Manager
}

export interface VageConfig {
  moveToTop?: boolean
}

class VageDragger implements VageDragInterface {
  private managers: Manager[] = []

  public add(element: HTMLElement, config: VageConfig = {}): Manager {
    const manager = new Manager(element, config)
    this.managers.push(manager)
    return manager
  }

  public remove(element: HTMLElement) {
    const index = this.managers.findIndex((manager: Manager) => manager.element === element)

    if (index !== -1) {
      const manager = this.managers[index]
      manager.deActivate()
      this.managers.splice(index, 1)
    }
  }
}

export default {
  install(Vue: typeof _Vue, options = { name: '$drag' }) {
    const instance: VageDragInterface = new VageDragger()

    Object.defineProperty(Vue.prototype, options.name, { value: instance })
  },
}
